import { LinearProgress } from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import MahasiswaSidangService from "../../../../../services/Integration/mahasiswa-sidang/MahasiswaSidangService";

export default function MKSpesialJadwalSidang({ mKSpesialId }) {
  const [isLoading, setIsLoading] = useState(true);
  const [mKSpesial, setMKSpesial] = useState(null);
  const [jadwalSidang, setJadwalSidang] = useState(null);

  useEffect(() => getJadwalSidang(), []);

  const getJadwalSidang = async () => {
    setIsLoading(true);
    await MahasiswaSidangService.getJadwalSidangByMKSpesialId(mKSpesialId)
      .then((response) => {
        if (response.status === 200) {
          setJadwalSidang(response.data.jadwal_sidang);
          setMKSpesial(response.data.mk_spesial);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
    setIsLoading(false);
  };

  return (
    <div className="mt-4 text-sm">
      {isLoading ? (
        <LinearProgress />
      ) : jadwalSidang !== null && mKSpesial !== null ? (
        <table id="prasidang-table">
          <tbody className="align-top">
            <tr>
              <td width={200}>
                <b>Jenis Tugas Akhir:</b>
              </td>
              <td>{mKSpesial.jenis_sidang}</td>
            </tr>
            <tr>
              <td width={200}>
                <b>Judul Tugas Akhir:</b>
              </td>
              <td>{mKSpesial.judul}</td>
            </tr>
            <tr>
              <td width={200}>
                <b>Tanggal Sidang:</b>
              </td>
              <td>
                {moment(jadwalSidang.tanggal, "YYYY-MM-DD").format(
                  "ddd, D MMM YYYY"
                )}
              </td>
            </tr>
            <tr>
              <td width={200}>
                <b>Waktu Sidang:</b>
              </td>
              <td>
                {moment(jadwalSidang.jam_mulai, "HH:mm:ss").format("HH:mm")}
                {" - "}
                {moment(jadwalSidang.jam_selesai, "HH:mm:ss").format("HH:mm")}
                {" WIB"}
              </td>
            </tr>
            <tr>
              <td width={200}>
                <b>Tempat Sidang:</b>
              </td>
              <td>
                {jadwalSidang.ruangan.kode_ruangan}
                {jadwalSidang.is_sidang_online === true ||
                (jadwalSidang.link_vicon !== null &&
                  jadwalSidang.link_vicon !== "") ? (
                  <>
                    {" @ "}
                    <a
                      href={jadwalSidang.link_vicon}
                      target="_blank"
                      rel="noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      Link
                    </a>
                  </>
                ) : (
                  ""
                )}
              </td>
            </tr>
            <tr>
              <td width={200}>
                <b>Dosen Pembimbing:</b>
              </td>
              <td>
                {
                  <ul className="list-disc ml-4">
                    {mKSpesial.pembimbing.map((dosen, index) => (
                      <li key={index}>{dosen.nama_lengkap}</li>
                    ))}
                  </ul>
                }
              </td>
            </tr>
            <tr>
              <td width={200}>
                <b>Dosen Penguji:</b>
              </td>
              <td>
                <ul className="list-disc ml-4">
                  {jadwalSidang.penguji.map((dosen, index) => (
                    <li key={index}>{dosen.nama_lengkap}</li>
                  ))}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <div className="w-full text-center font-bold">
          <div className="text-lg">Perhatian!</div>
          <div>
            Jadwal sidang belum dibuat. Hubungi dosen pembimbing untuk
            menyetujui maju sidang atau sekretariat untuk dibuatkan jadwal
            sidang.
          </div>
        </div>
      )}
    </div>
  );
}
